import { forgotPassword } from "../../store/auth/authActionAsync";

export const routePaths = {
  base: "/",
  media: "media",
  story: "story",
  concert: "concert",
  mediaCategories: "media/categories",
  pagesSections: "pages/sections",
  pagesRivals: "pages/rivals",
  pagesSubscriptions: "pages/subscriptions",
  partners: "partners",
  calendar: "calendar",
  tournaments: (id = "", form?: string) => `tournaments${id ? `/${id}` : ""}${form ? `/${form}` : ""}`,
  matchDay: (id = "", form?: string) => `matchDay${id ? `/${id}` : ""}${form ? `/${form}` : ""}`,
  matches: (id = "", form?: string) => `matches${id ? `/${id}` : ""}${form ? `/${form}` : ""}`,
  matching: "matching",
  matchesPromo: "matchesPromo",
  clubsTeams: "clubs/teams",
  clubsPlayers: "clubs/players",
  clubsTrainers: "clubs/trainers",
  clubsStaff: "clubs/staff",
  clubsMedical: "clubs/medical",
  clubsLeadership: "clubs/leadership",
  clubsScouts: "clubs/scouts",
  dirStadiums: "directories/stadiums",
  dirTeams: "directories/teams",
  advertising: "advertising",
  employee: "employee",
  employeeRole: "employee/role",
  usersView: "users/view",
  systemLog: "systemLog",
  notificationsClub: (tab = ":tab") => `notifications/club/${tab}`,
  notificationsCRM: (tab = ":tab") => `notifications/CRM/${tab}`,
  predictor: "predictor",
  information: "information",
  organizationsCallForFootball: "callForFootball/organizations",
  devisionsCallForFootball: "callForFootball/devisions",

  //заявки на сборы
  matchApplicationCallForFootball: "callForFootball/match-application",
  matchApplicationCreate: "callForFootball/match-application/create",
  matchApplicationEdit: (id = ":id") => `callForFootball/match-application/edit/${id}`,
  matchApplications: (id = ":id") => `callForFootball/match-applications/${id}`,
  matchApplicationsOrganization: (id = ":id") => `callForFootball/match-applications/organization/${id}`,

  representativesCallForFootball: "callForFootball/representatives",
  participantsCallForFootball: "callForFootball/participants",
  levelsCallForFootball: "callForFootball/levels",
  tagsCallForFootball: "callForFootball/tags",
  representativeDetailsCallForFootball: (id = ":id") => `callForFootball/representatives/${id}`,
  backup: "backup",
  settings: "settings",
  bestPlayer: "promo/best-player",
  graduates: "graduates",
  graduateSections: "graduate-sections",
  kidsJournals: "kids-journals",
  kidsSeasons: "kids-seasons",
  kidsBidToExit: "bids-to-exit",
  loyalty: "loyalty",
  specialOffer: "specialOffer",
  quiz: "quiz",
  polls: "polls",
  sign: {
    auth: "auth",
    forgotPassword: "forgotPassword",
    recoveryPassword: "recoveryPassword",
    invitation: "invitation",
    recoveryPasswordSuccess: "recoveryPasswordSuccess/:type",
    invitationSuccess: "invitationSuccess/:type",
    recoveryPasswordError: "recoveryPasswordError/:type",
    invitationError: "invitationError/:type",
  },
  form: {
    create: "create",
    edit: (id = ":id") => id,
  },
};
